<template v-slot:default>
    <Popup ref="popup" :animation="'scale'" :shadowOpacity="0.7" @ontransitionend="onTransitionEnd">
        <div class="collect-cont" :style="landscapeScale < 1 ? { transform: `scale(${landscapeScale})` } : {}">
            <div class="rewards">
                <img class="collect-bg" :src="_global.isMobile
                    ? _global.assetsRoot + '/mobile/web_phone_pop_payment_success_bg.png'
                    : _global.assetsRoot + '/desktop/web_pc_pop_payment_success_bg.png'" />
                <div class="items">
                    <div class="title">
                        <img :src="_global.assetsRoot + '/common/pop_payment_success_' + _i18n.locale + '.png'" />
                    </div>
                    <div class="text" :class="{ 'text-low-items': itemCount < 4 }">
                        <span class="beba">{{ creditText }}</span>
                    </div>
                    <div class="reward-items">
                        <div class="coins reward v-m" v-if="data.coins > 0">
                            <div class="coins-icon icon t-c">
                                <img class="v-m" :src="_global.assetsRoot + '/common/icon_payment_coins.png'" />
                            </div>
                            <div class="icon-label t-c"><span class="beba">COINS</span></div>
                            <div class="coins-count count t-c">
                                <span class="segoe fs-2-5">{{ coins }}</span>
                            </div>
                        </div>
                        <div class="chips reward v-m" v-if="data.chips > 0">
                            <div class="chips-icon icon t-c">
                                <img class="v-m" :src="_global.assetsRoot + '/common/icon_payment_dinero.png'" />
                            </div>
                            <div class="icon-label t-c"><span class="beba">DINERO</span></div>
                            <div class="chips-count count t-c">
                                <span class="segoe fs-2-5">{{ chips }}</span>
                            </div>
                        </div>
                        <div class="wheel reward v-m" v-if="data.is_wheel">
                            <div class="wheel-icon icon t-c">
                                <img class="v-m" :src="_global.assetsRoot + '/common/icon_payment_freewheel​​​.png'" />
                            </div>
                            <div class="icon-label t-c"><span class="beba">FREE WHEEL</span></div>
                            <div class="wheel-text count t-c">
                                <span class="segoe fs-2">{{ free_wheel }}</span>
                            </div>
                        </div>
                        <div class="wheel reward v-m" v-if="data.is_black_wheel">
                            <div class="wheel-icon icon t-c">
                                <img class="v-m" :src="_global.assetsRoot + '/common/icon_payment_blackwheel.png'" />
                            </div>
                            <div class="icon-label t-c"><span class="beba">FREE BLACK WHEEL</span></div>
                            <div class="wheel-text count t-c">
                                <span class="segoe fs-2">{{ free_black_wheel }}</span>
                            </div>
                        </div>
                        <div class="wheel reward v-m" v-if="data.bp">
                            <div class="wheel-icon icon t-c">
                                <img class="v-m" :src="_global.assetsRoot + '/common/icon_payment_bp.png'" />
                            </div>
                            <div class="icon-label t-c"><span class="beba">VIP</span></div>
                            <div class="wheel-text count t-c">
                                <span class="segoe fs-2">{{ bp }}</span>
                            </div>
                        </div>
                        <div class="chips reward v-m golden-token" v-if="data.golden_token > 0">
                            <div class="chips-icon icon t-c">
                                <img class="v-m" :src="_global.assetsRoot + '/common/icon_payment_goldentoken​​​.png'" />
                            </div>
                            <div class="icon-label t-c"><span class="beba">GOLDEN TOKEN</span></div>
                            <div class="golden-token-count count t-c">
                                <span class="segoe fs-2-5">{{ golden_token }}</span>
                            </div>
                            <div class="claw-btn t-c" @click.stop="goToClaw">
                                <img :src="_global.assetsRoot + '/common/pop_btn_claw_' + _i18n.locale + '.png'" />
                            </div>
                        </div>
                    </div>
                    <div class="btn-item">
                        <div ref="collectBtn" class="btn collect-btn t-c" @click.stop="collect">
                            <span class="beba fs-1-2">{{ $t("message.okay") }}</span>
                        </div>
                        <!--div ref="goDrBingoBtn" class="btn go-dr-bingo-btn t-c" @click.stop="goDrBingo">
                            <span class="segoe fs-1-2">{{ $t("message.goDrBingo") }}</span>
                        </div-->
                    </div>
                </div>
            </div>
        </div>
        <template v-slot:second="">
            <BonusAnimation ref="bonusAnimation" :from="from" :to="to"></BonusAnimation>
        </template>
    </Popup>
</template>

<script>
import Popup from '../Popup.vue';
import BonusAnimation from '../animations/BonusAnimation.vue';
import utils from '../../utils/utils.js';
export default {
    props: {
        data: Object,
        to: Object
    },
    data() {
        return {
            isShow: false,
            from: null,
            collected: false,
            landscapeScale: 1
        }
    },
    computed: {
        coins() { return utils.fc(this.data ? (this.data.coins || 0) : 0) },
        chips() { return utils.fc(this.data ? (this.data.chips || 0) : 0) },
        golden_token() { return utils.fc(this.data ? (this.data.golden_token || 0) : 0) },
        bp() { return utils.fc(this.data ? (this.data.bp || 0) : 0) },
        free_wheel() { return this.data ? (this.data.is_wheel || 0) : 0 },
        free_black_wheel() { return this.data ? (this.data.is_black_wheel || 0) : 0 },
        creditText() {
            if(this.data.type){
                if(this.data.type == 'web_rolling_po'){
                    if(this.data.isFree){
                        return this.$t("message.rollingCreditedFree")
                    }
                    else{
                        return this.$t("message.rollingCredited")
                    }
                }
                else{
                    return this.$t("message.regularCredited")
                }
            }
        },
        itemCount() {
            let count = 0;
            if(this._global.isMobile){
                if (this.data.coins > 0) count++;
                if (this.data.chips > 0) count++;
                if (this.data.is_wheel || this.data.is_black_wheel) count++;
                if (this.data.bp) count++;
                if (this.data.golden_token > 0) count++;
            }
            return count;
        }
    },
    methods: {
        show() {
            if (window.innerWidth > window.innerHeight) {
                //console.log(window.innerHeight, window.innerWidth);
                this.landscapeScale = Math.min((window.innerHeight * 0.8) / (window.innerWidth * 0.6), 1);
            } else {
                this.landscapeScale = 1;
            }
            this.isShow = true;
            this.$refs.popup.show();
            this.collected = false;
        },
        hide() { this.isShow = false, this.$refs.popup.hide() },
        onTransitionEnd() {
            if (this.isShow) {
                let pos = this.$refs.collectBtn.getBoundingClientRect();
                this.from = { x: pos.left + pos.width / 2, y: pos.top + pos.height / 2 };
            }
        },
        goToClaw() {
            this.$emit('go-claw');
            this.hide();
        },
        collect() {
            if (this.collected) return;
            this.collected = true;
            if (typeof this.data.isFree !== 'undefined' && this.data.isFree) {
                this.$emit("claimFree");
                let items = [];
                this.data.coins && this.data.coins > 0 && items.push({ "type": "coins", "data": this.data.coins });
                this.data.chips && this.data.chips > 0 && items.push({ "type": "chips", "data": this.data.chips });
                this.data.golden_token && this.data.golden_token > 0 && items.push({ "type": "golden_token", "data": this.data.golden_token });
                this.$emit("tanimation", { items: items })
                this.showBonusAnimation();
            } else this.$emit("collect", { pendingId: this.data.pendingId });
        },
       goDrBingo() {
        const appUrlScheme = "drbingo://";
        const fallbackUrlAndroid = "https://play.google.com/store/apps/details?id=com.gamesmartltd.doctorbingo";
        const fallbackUrliOS = "https://apps.apple.com/us/app/dr-bingo-videobingo-slots/id1152226735";
        const fallbackUrlDesktop = "https://www.drbingo.com/";

        const userAgent = navigator.userAgent || navigator.vendor || window.opera;

        const openApp = () => {
            if ((/android/i.test(userAgent)) || ((/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream))) {
                window.location.href = appUrlScheme;
            }else {
                this.$refs.popup.hide();
                window.open(fallbackUrlDesktop, '_blank');
            }
        };

        const openFallbackUrl = () => {
            if (/android/i.test(userAgent)) {
                window.open(fallbackUrlAndroid, '_blank');
            } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                window.open(fallbackUrliOS, '_blank');
            } else {
                window.open(fallbackUrlDesktop, '_blank');
            }
        };

        // Check if the app is installed
        const iframe = document.createElement("iframe");
        iframe.style.display = "none";
        iframe.src = appUrlScheme;
        document.body.appendChild(iframe);

        const timeout = setTimeout(() => {
            if (document.body.contains(iframe)) {
                document.body.removeChild(iframe);
                openFallbackUrl();
            }
        }, 2000);

        window.addEventListener('blur', () => {
            clearTimeout(timeout);
            if (document.body.contains(iframe)) {
                document.body.removeChild(iframe);
            }
        }, { once: true });

        openApp();
    },
        showBonusAnimation() {
            //console.log("am i called");
            this.$refs.bonusAnimation.show();
            this.$refs.bonusAnimation.startAnimation(this.data.coins && this.data.coins > 0, this.data.chips && this.data.chips > 0, this.data.golden_token && this.data.golden_token > 0, this.from, this.to, () => {
                this.hide()
                setTimeout(() => {
                    //console.log("showbonus");
                    this.$emit("collectFree");
                }, 500);
            });
        }
    },
    components: { Popup, BonusAnimation }
}
</script>

<style lang="scss">
@import "../../assets/css/variables.scss";

.collect-cont {
    display: inline-block;
    transform-origin: center center;

    .rewards {
        position: relative;

        .collect-bg {
            width: 100%;
        }

        .items {
            position: absolute;
            width: 100%;
            left: 0;
            top: 37.5%;

            .title {
                img {
                    width: 45%;
                    height: auto;
                }
            }

            .text {
                width: 100%;
                margin-left: 0%;
                margin-top: 20px;
                height: 75px;

                &.text-low-items {
                    /*margin-bottom: 1%;*/
                    width: 97%;
                    margin-left: 20px;
                }

                span {
                    font-size: 35px;
                    color: #FFF;
                    letter-spacing: 1px;
                    font-weight: bold;
                    text-shadow:
                        -1px -1px 0 #2641bf,
                        0px -1px 0 #2641bf,
                        1px -1px 0 #2641bf,
                        -1px  0px 0 #2641bf,
                        1px  0px 0 #2641bf,
                        -1px  1px 0 #2641bf,
                        0px  1px 0 #2641bf,
                        1px  1px 0 #2641bf;
                }
            }

            .reward-items {
                box-sizing: border-box;
                display: flex;
                flex-wrap: wrap;
                /*padding: 1rem 2rem;*/
                gap: 1rem;
                justify-content: center;
                align-items: flex-start;

                .reward {
                    width: 18%;
                    height: 18%;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    background: url($assetRoot + '/common/pop_payment_success_icon_bg.png') center no-repeat;
                    background-size: 100% 100%;
                    background-position: center;

                    .icon {
                        flex-basis: auto;
                        height: 145px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        margin-top: 15px;
                        margin-bottom: -20px;

                        img {
                            height: 100%;
                            width: auto;
                        }
                    }

                    .count {
                        flex: 0;
                        text-align: center;
                        background: url($assetRoot + '/common/header_price_bg.png') center no-repeat;
                        background-size: 100% 100%;
                        padding: 0 25px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        white-space: nowrap;
                        width: auto;
                        height: auto;
                        min-width: 75px;
                        min-height: 30px;
                        margin-bottom: 20px;
                    }

                    .icon-label {
                        span {
                            color: #FFF;
                            font-size: 35px;
                            font-weight: bold;
                            text-shadow:
                                -1px -1px 0 #4d1daf,
                                0px -1px 0 #4d1daf,
                                1px -1px 0 #4d1daf,
                                -1px  0px 0 #4d1daf,
                                1px  0px 0 #4d1daf,
                                -1px  1px 0 #4d1daf,
                                0px  1px 0 #4d1daf,
                                1px  1px 0 #4d1daf;
                        }
                    }

                    .coins-count span {
                        color: #FFFFFF;
                        font-size: 35px;
                        font-weight: bold;
                    }

                    .chips-count span {
                        color: #FFFFFF;
                        font-size: 35px;
                        font-weight: bold;
                    }

                    .golden-token-count span {
                        color: #FFFFFF;
                        font-size: 35px;
                        font-weight: bold;
                    }

                    .wheel-text span {
                        color: #FFFFFF;
                        font-size: 35px;
                        font-weight: bold;
                    }

                    .claw-btn {
                        cursor: pointer;

                        img {
                            width: 80%;
                            height: auto;
                        }
                    }
                }

                .golden-token {
                    .icon {
                        margin-top: unset;
                        height: 115px;
                        img {
                            width: auto;
                        }
                    }

                    .count{
                        margin-bottom: unset;
                    }

                    .claw-btn {
                        margin-top: 0;
                    }
                }
            }

            .btn-item {
                position: absolute;
                margin-top: 5%;
                width: 100%;
                left: 0;
                display: flex;
                justify-content: center;

                .collect-btn {
                    display: inline-block;
                    width: 300px;
                    height: 80px;
                    line-height: 75px;
                    background: url($assetRoot + "/common/btn_buy.png") center no-repeat;
                    background-size: 100% 100%;

                    span {
                        color: #FFF;
                        font-size: 60px;
                        font-weight: bold;
                        text-shadow:
                            -1px -1px 0 #000000,
                            0px -1px 0 #000000,
                            1px -1px 0 #000000,
                            -1px  0px 0 #000000,
                            1px  0px 0 #000000,
                            -1px  1px 0 #000000,
                            0px  1px 0 #000000,
                            1px  1px 0 #000000;
                    }
                }
            }
        }
    }
}

@media (min-width: 769px) {
    .collect-cont {
        .rewards {
            .items {
                bottom: 0;

                .btn-item {
                    top: auto;
                    bottom: 0;
                    margin-top: 0;
                }
            }
        }
    }
}

.mobile{
    .collect-cont {
        .rewards {
            position: relative;

            .collect-bg {
                width: 85vw;
            }

            .items {
                top: 40vw;
                
                .title {
                    img {
                        width: 40vw;
                    }
                }


                .text {
                    margin-top: 4vw;
                    width: 75vw;
                    margin-left: 6vw;
                    height: unset;

                    &.text-low-items {
                        margin-bottom: 4vw;
                        margin-top: 10vw;
                    }

                    span {
                        font-size: 3.5vw;
                    }
                }

                .reward-items {
                    gap: unset;
                    .reward {
                        width: 25vw;
                        height: 25vw;

                        .icon {
                            width: 16vw;
                            height: 8vw;
                            margin-top: unset;
                            margin-bottom: unset;
                            img {
                                height: 10vw;
                            }
                        }

                        .icon-label {
                            span {
                                font-size: 4vw;
                            }
                        }

                        .count {
                            padding: 2vw 4vw;
                            min-width: 8vw;
                            min-height: 1vw;
                            margin-top: 1vw;
                            margin-bottom: unset;
                        }

                        .coins-count span {
                            font-size: 4vw;
                        }

                        .chips-count span {
                            font-size: 4vw;
                        }

                        .golden-token-count span {
                            font-size: 4vw;
                        }

                        .wheel-text span {
                            font-size: 4vw;
                        }

                        .claw-btn {
                            img {
                                width: 18vw;
                            }
                        }
                    }

                    .golden-token {
                        .icon {
                            img {
                                height: 6vw;
                            }
                        }
                    }
                }

                .btn-item {
                    top: 72vw;
                    margin-top: unset;

                    .collect-btn {
                        width: 40vw;
                        height: 11vw;
                        line-height: 11vw;

                        span {
                            font-size: 7vw;
                        }
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/popup/Collect.vue